import React from 'react';

import Button, { BUTTON_COLORS, BUTTON_VARIANTS } from 'js/src/components/common/ui/Button';

type CountdownTimerProps = {
    count: string;
};

const CountdownTimer: React.FC<CountdownTimerProps> = ({ count }) => {
    return <Button text={count} color={BUTTON_COLORS.DANGER} variant={BUTTON_VARIANTS.OUTLINE} />;
};
export default React.memo(CountdownTimer);
